import StudentTaskBlock from './student-task-block'

export default StudentTaskBlock
